export const updateQRCodes = (payload) => {
    return {
        type: 'qrCodes/update',
        payload
    }
} 